import React, { ReactElement, useEffect, useRef } from 'react'
import cx from 'classnames'
import './styles.css'
import '../../../styles/components/global/mobile.css'

import BlockContent from 'src/components/global/BlockContent'

import { Serializer } from 'src/utils/serializer'
import { Image, SafeImage } from 'src/components/image'
import {
  HeroShapeOne,
  HeroShapeTwo,
  HeroShapeThree,
  HeroShapeFour,
} from './heroShapes'
import { useMediaQuery } from 'src/hooks/useMediaQuery'

export interface HeroProps {
  data: {
    text: any[]
    backgroundColor?: string
    containerSize?: string
    shapes: any[]
    spacing?: string
    heroImage: { asset: { _id: string; _ref?: string } }
    heroMobileImage: { asset: { _id: string; _ref?: string } }
    ctaAboveImage: boolean
    bgImage: string
    imageColor: string
  }
}

export const Hero = ({ data }: HeroProps): ReactElement => {
  const {
    text,
    backgroundColor,
    containerSize,
    spacing,
    heroImage,
    heroMobileImage,
    ctaAboveImage,
    bgImage,
    imageColor = 'primary-1',
  } = data
  const { isMobileDevice } = useMediaQuery()

  const shapesMapping: { [key: string]: ReactElement } = {
    ShapeOne: (
      <HeroShapeOne
        className={cx('abs hero-backgroundImage top right', imageColor)}
      />
    ),
    ShapeTwo: (
      <HeroShapeTwo
        className={cx('abs hero-backgroundImage top right', imageColor)}
      />
    ),
    ShapeThree: (
      <HeroShapeThree
        className={cx('abs hero-backgroundImage top right', imageColor)}
      />
    ),
    ShapeFour: (
      <HeroShapeFour
        className={cx('abs hero-backgroundImage top right', imageColor)}
      />
    ),
  }

  const ImageElement = bgImage ? shapesMapping[bgImage] : null

  const desktopImageIdentifier = heroImage?.asset?._id || heroImage?.asset?._ref
  const mobileImageIdentifier =
    heroMobileImage?.asset?._id ||
    heroMobileImage?.asset?._ref ||
    desktopImageIdentifier
  const mobileImageRaw = heroMobileImage || heroImage

  return (
    <div
      className={cx('rel', 'is-visible', backgroundColor, spacing, {
        cw: backgroundColor === 'bcb',
        pyl: spacing === undefined,
        'cw bcb': backgroundColor === undefined,
      })}
    >
      {ImageElement}
      <div
        className={cx(
          'container--l outer mxa hero__inner f jcs ais py2 p1 al x rel',
          {
            row: ctaAboveImage,
          }
        )}
      >
        <div
          className={cx('x animate opacity slide-up d2 col-m-7 col-xs-24', {
            containerSize,
            mxa: !!desktopImageIdentifier,
          })}
        >
          <BlockContent blocks={text} serializers={Serializer} />
        </div>

        {isMobileDevice ? (
          <div className="x cw rel col-xs-24 show__mobile">
            <SafeImage imageId={mobileImageIdentifier} raw={mobileImageRaw} />
          </div>
        ) : (
          (
            <div className="x cw rel col-xs-24 show__desktop">
              <SafeImage imageId={desktopImageIdentifier} raw={heroImage} />
            </div>
          )
        )}
      </div>
    </div>
  )
}

export default Hero
